import _ from 'underscore';

// TO DO: update this when new entity type is created
const ExternalEntityType = {
  XandrAdvertiser: 8,
};

export const isValidXandrAccount = (account) => {
  if (account && account.ExternalAccountIds && account.ExternalAccountIds.length > 0) {
    // TO DO switch this to new enetity type when its available
    const externalAccountId = _.find(account.ExternalAccountIds, item => item.Type === ExternalEntityType.XandrAdvertiser);
    return externalAccountId && externalAccountId.Id !== null && externalAccountId.Id !== undefined;
  }
  // TO DO switch to false
  return true;
};
